import {
  AlertOutlined,
  BarChartOutlined,
  CustomerServiceOutlined,
  DeleteOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  HomeOutlined,
  InboxOutlined,
  KeyOutlined,
  LoginOutlined,
  LogoutOutlined,
  ShopOutlined,
  TableOutlined,
  TagsOutlined,
  UserOutlined,
} from "@ant-design/icons";
import React from "react";
import { ROLES } from "./permissions";

export const routes = {
	home: {
		key: "home",
		slug: "home",
		to: "/home",
		title: "Inicio",
		icon: <HomeOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role, ROLES.hotel_admin.role],
	},
	containers: {
		key: "containers",
		slug: "containers",
		to: "/containers",
		title: "Contenedores",
		icon: <InboxOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role, ROLES.hotel_admin.role],
	},
	containermeasurements: {
		key: "containermeasurements",
		slug: "containermeasurements",
		to: "/containermeasurements",
		title: "Mediciones",
		icon: <BarChartOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role, ROLES.hotel_admin.role],
	},
	reports: {
		key: "reports",
		slug: "reports",
		to: "/reports",
		title: "Informes",
		icon: <FileTextOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role, ROLES.hotel_admin.role],
	},
	hoteldata: {
		key: "hoteldata",
		slug: "hoteldata",
		to: "/hoteldata",
		title: "Datos hoteles",
		icon: <TableOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role, ROLES.hotel_admin.role],
	},
	alertas: {
		key: "alertas",
		slug: "alertas",
		to: "/alertas",
		title: "Gestión de alertas",
		icon: <AlertOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role, ROLES.hotel_admin.role],
	},

	login: {
		key: "login",
		slug: "login",
		to: "/login",
		title: "LOGIN",
		icon: <LoginOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role, ROLES.hotel_admin.role],
	},

	hotelchains: {
		key: "hotelchains",
		slug: "hotelchains",
		to: "/hotelchains",
		title: "Cadenas",
		icon: <HomeOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
	establishments: {
		key: "establishments",
		slug: "establishments",
		to: "/establishments",
		title: "Establecimientos",
		icon: <ShopOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role],
	},
	zones: {
		key: "zones",
		slug: "zones",
		to: "/zones",
		title: "Zonas",
		icon: <EnvironmentOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role, ROLES.hotel_admin.role],
	},
	wastetypes: {
		key: "wastetypes",
		slug: "wastetypes",
		to: "/wastetypes",
		title: "Tipos de residuos",
		icon: <DeleteOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
	zonecategories: {
		key: "zonecategories",
		slug: "zonecategories",
		to: "/zonecategories",
		title: "Categorías Zonas",
		icon: <TagsOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
supports: {
    key: "supports",
    slug: "supports",
    to: "/supports",
    title: "Soporte",
    icon: <CustomerServiceOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
},
	logout: {
		key: "logout",
		slug: "logout",
		to: "/logout",
		title: "Log out",
		icon: <LogoutOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role, ROLES.hotel_admin.role],
	},
	profile: {
		key: "profile",
		slug: "profile",
		to: "/profile",
		title: "Perfil",
		icon: <UserOutlined />,
		showInMenu: false,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role, ROLES.hotel_admin.role],
	},
	users: {
		key: "users",
		slug: "users",
		to: "/users",
		title: "Usuarios",
		icon: <UserOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.hotelchain_admin.role],
	},
	roles: {
		key: "roles",
		slug: "roles",
		to: "/roles",
		title: "Roles",
		icon: <KeyOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
};

export const MENU_PERMISSION_OPTIONS = Object.values(routes)
	.filter((route) => route.showInMenu)
	.map((route) => ({
		label: route.title,
		value: route.key,
	}));
